export default __webpack_public_path__ + "static/media/CSS3.57feb85c.png";